import { render, staticRenderFns } from "./AssignDriverToTrip.vue?vue&type=template&id=24506174"
import script from "./AssignDriverToTrip.vue?vue&type=script&lang=js"
export * from "./AssignDriverToTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports